import { Button, PlusIcon } from '@customink/pigment-react';
import { useCallback, useState } from 'react';
import { CreateTeamWizard } from '~/components/MultiAccountManagement/Wizard/CreateTeamWizard';

export function CreateTeamButton({ variant = 'secondary' }: { variant?: 'secondary' | 'link' }) {
    const [isWizardOpen, setIsWizardOpen] = useState(false);

    const handleOpen = useCallback(() => setIsWizardOpen(true), []);
    const handleClose = useCallback(() => setIsWizardOpen(false), []);

    return (
        <>
            <Button onClick={handleOpen} startIcon={<PlusIcon />} fullWidth variant={variant}>
                Create Team
            </Button>
            <CreateTeamWizard open={isWizardOpen} onClose={handleClose} />
        </>
    );
}
